'use strict';
(function () {
    $(document).ready(function () {
        var aptisPopUpBtn = $('.btn-aptis-popup');
        var aptisModal = $('#aptis-modal');
        var aptisModalContent = '#modal-content';

        aptisPopUpBtn.on('click', function (e) {
            e.preventDefault();
            var href = $(this).attr('data-url');

            $.get(href, function (data) {
                aptisModal.modal('show')
                    .find(aptisModalContent)
                    .html(data);
            });
        });
    });
})();